import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";

const UF_LIST = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP",
  "SE",
  "TO",
];

interface UfSelectProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const UfSelect = ({ value, onChange, disabled }: UfSelectProps) => (
  <Select value={value} onValueChange={onChange} disabled={disabled}>
    <SelectTrigger>
      <SelectValue placeholder="Selecione" />
    </SelectTrigger>
    <SelectContent>
      {UF_LIST.map((uf) => (
        <SelectItem key={uf} value={uf}>
          {uf}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
